module.exports = __webpack_public_path__ + "img/evaluateItemLogo6.a2a16406.png";